import uid from "common/utils/uid";
import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_115: DocMigration = {
  maxSchemaVersion: "0.0.115",
  description: "Converting roof dormers and skylights into doc entities",
  apply(json: any) {
    if (json.roofs) {
      const { roofs } = json;

      const newDormers = {};
      const newSkylights = {};
      const newGableOpenings = {};

      for (const roofId in roofs) {
        const roof = roofs[roofId];
        const { dormers, skylights, gableOpenings } = roof;

        // migrate dormers
        if (dormers) {
          for (let i = 0, l = dormers.length; i < l; i++) {
            const dormer = dormers[i];
            const id = uid();
            newDormers[id] = {
              ...dormer,
              name: `Dormer ${i + 1}`,
              parentId: roofId,
              id,
            };
          }

          delete roof.dormers;
        }

        // migrate skylights
        if (skylights) {
          for (let i = 0, l = skylights.length; i < l; i++) {
            const skylight = skylights[i];
            const id = uid();
            newSkylights[id] = {
              ...skylight,
              name: `Skylight ${i + 1}`,
              parentId: roofId,
              id,
            };
          }

          delete roof.skylights;
        }

        // migrate gable openings
        if (gableOpenings) {
          for (let i = 0, l = gableOpenings.length; i < l; i++) {
            const gableOpening = gableOpenings[i];
            const id = uid();
            newGableOpenings[id] = {
              ...gableOpening,
              name: `Gable Opening ${i + 1}`,
              parentId: roofId,
              id,
            };
          }

          delete roof.gableOpenings;
        }
      }

      json.dormers = newDormers;
      json.skylights = newSkylights;
      json.gableOpenings = newGableOpenings;
    }

    return json;
  },
};

export default migration_0_0_115;
